import React, { useState } from 'react';
import { HiOutlineChatBubbleLeftRight } from 'react-icons/hi2';

// Claude logo — Anthropic's official Claude mark, self-hosted from /public and
// displayed unmodified (no recolor, no re-proportioning), per Anthropic's
// trademark guidelines. Used nominatively, to identify the Claude product this
// integration works with — Claude always appears as the counterparty, never as
// our own branding. If the image can't load, we fall back to a neutral chat
// glyph in a muted gray (deliberately NOT the Claude coral — a recolored mark
// would be an altered trademark), so the UI degrades to a generic placeholder
// rather than a modified logo.
const ClaudeMark = ({ className = 'w-6 h-6', rounded = 'rounded-md' }) => {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return <HiOutlineChatBubbleLeftRight className={`${className} text-gray-400 dark:text-gray-500`} role="img" aria-label="Claude" />;
  }
  return (
    <img
      src="/claude-mark.png"
      alt="Claude"
      className={`${className} ${rounded} object-contain`}
      onError={() => setFailed(true)}
    />
  );
};

export default ClaudeMark;
